import React from "react";
import { AddUserPage } from "./add-page";

export default props => (
  <AddUserPage backTo="/users" username={props.match.params.id} />
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users/Add.js